import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. Import useTranslation
import { FaTools, FaHeartbeat, FaGraduationCap, FaLightbulb, FaShieldAlt, FaClock, FaHandshake } from 'react-icons/fa';
import "./App.css";
import "./services.css";
import "./Navbar.js";

export default function Services() {
  const { t } = useTranslation(); // 2. เรียกใช้ Hook แปลภาษา

  const services = [
    {
      icon: <FaTools />,
      title: t('service1Title', 'การจัดหาเครื่องมือแพทย์'),
      description: t('service1Desc', 'เราจัดหาเครื่องมือแพทย์คุณภาพสูง มาตรฐานสากล พร้อมแนะนำรุ่นที่เหมาะสมกับงบประมาณและความต้องการของคุณ'),
      features: [
        t('service1Feat1', 'นำเข้าจากผู้ผลิตชั้นนำ'), 
        t('service1Feat2', 'มาตรฐาน FDA & CE'), 
        t('service1Feat3', 'รับประกันคุณภาพ')
      ]
    },
    {
      icon: <FaHeartbeat />,
      title: t('service2Title', 'การบำรุงรักษาเครื่องมือแพทย์'),
      description: t('service2Desc', 'บริการตรวจเช็ค ซ่อม และบำรุงรักษาอุปกรณ์อย่างสม่ำเสมอ เพื่อยืดอายุการใช้งานและลดความเสี่ยงจากความเสียหาย'),
      features: [
        t('service2Feat1', 'ตรวจสอบประจำปี'), 
        t('service2Feat2', 'ซ่อมแซมด่วน 24/7'), 
        t('service2Feat3', 'ทีมช่างมืออาชีพ')
      ]
    },
    {
      icon: <FaGraduationCap />,
      title: t('service3Title', 'การฝึกอบรมการใช้งานเครื่องมือแพทย์'),
      description: t('service3Desc', 'อบรมบุคลากรทางการแพทย์ให้เข้าใจการใช้งานอุปกรณ์อย่างถูกต้อง ปลอดภัย และมีประสิทธิภาพสูงสุด'),
      features: [
        t('service3Feat1', 'วิทยากรผู้เชี่ยวชาญ'), 
        t('service3Feat2', 'ฝึกปฏิบัติจริง'), 
        t('service3Feat3', 'ใบรับรองหลังอบรม')
      ]
    },
    {
      icon: <FaLightbulb />,
      title: t('service4Title', 'การให้คำปรึกษาด้านเทคโนโลยีการแพทย์'),
      description: t('service4Desc', 'คำแนะนำเชิงเทคนิคและการเลือกเทคโนโลยีที่เหมาะสม ช่วยให้คุณตัดสินใจซื้อและใช้อุปกรณ์ได้อย่างคุ้มค่า'),
      features: [
        t('service4Feat1', 'วิเคราะห์ความต้องการ'), 
        t('service4Feat2', 'แนะนำเทคโนโลยีใหม่'), 
        t('service4Feat3', 'คำนวณ ROI')
      ]
    }
  ];

  const benefits = [
    {
      icon: <FaShieldAlt />,
      title: t('benefit1Title', 'มาตรฐานสากล'),
      description: t('benefit1Desc', 'อุปกรณ์ผ่านการรับรองมาตรฐานระดับสากล')
    },
    {
      icon: <FaClock />,
      title: t('benefit2Title', 'บริการรวดเร็ว'),
      description: t('benefit2Desc', 'ตอบสนองทุกความต้องการอย่างรวดเร็ว')
    },
    {
      icon: <FaHandshake />,
      title: t('benefit3Title', 'บริการหลังการขาย'),
      description: t('benefit3Desc', 'ดูแลและสนับสนุนหลังการขายอย่างต่อเนื่อง')
    }
  ];

  return (
    <section className="services-page">
      {/* Header */}
      <div className="services-header">
        <h1>{t('servicesPageTitle', 'บริการของเรา')}</h1>
        <p className="services-tagline">{t('servicesTagline', 'ครบวงจร มืออาชีพ เชื่อถือได้')}</p>
      </div>

      {/* Intro */}
      <div className="services-intro">
        <p>
          {t('servicesIntro', 'บริษัท แอสเซนท์ คอร์ปอเรชั่น จำกัด มุ่งมั่นให้บริการด้านเครื่องมือแพทย์ครบวงจร ทั้งการจัดหา การบำรุงรักษา และให้คำปรึกษาอย่างมืออาชีพ เพื่อให้สถานพยาบาลของคุณใช้งานได้อย่างเต็มประสิทธิภาพและปลอดภัย')}
        </p>
      </div>

      {/* Main Services */}
      <div className="services-main">
        <h2 className="section-title">{t('mainServicesTitle', 'บริการหลักของเรา')}</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{'--index': index}}>
              <div className="service-icon-wrapper">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>
                    <span className="check-icon">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2 className="section-title">{t('whyChooseUsTitle', 'ทำไมต้องเลือกเรา')}</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Process Section */}
      <div className="process-section">
        <h2 className="section-title">{t('serviceProcessTitle', 'ขั้นตอนการให้บริการ')}</h2>
        <div className="process-timeline">
          <div className="process-step">
            <div className="step-number">1</div>
            <h3>{t('process1Title', 'ปรึกษาความต้องการ')}</h3>
            <p>{t('process1Desc', 'วิเคราะห์และรับฟังความต้องการของคุณอย่างละเอียด')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <h3>{t('process2Title', 'เสนอแนะแนวทาง')}</h3>
            <p>{t('process2Desc', 'นำเสนอโซลูชั่นที่เหมาะสมพร้อมราคาที่คุ้มค่า')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <h3>{t('process3Title', 'ติดตั้งและอบรม')}</h3>
            <p>{t('process3Desc', 'ติดตั้งอุปกรณ์และอบรมการใช้งานอย่างละเอียด')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <h3>{t('process4Title', 'ดูแลหลังการขาย')}</h3>
            <p>{t('process4Desc', 'บริการบำรุงรักษาและแก้ไขปัญหาอย่างต่อเนื่อง')}</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="services-cta">
        <div className="cta-content">
          <h2>{t('readyToServeTitle', 'พร้อมให้บริการคุณแล้ววันนี้')}</h2>
          <p>{t('readyToServeDesc', 'ปรึกษาฟรี! ทีมผู้เชี่ยวชาญพร้อมให้คำแนะนำที่เหมาะสมกับคุณ')}</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-link primary">{t('contactUsNow', 'ติดต่อเราเลย')}</Link>
            <Link to="/products" className="cta-link secondary">{t('viewProductsBtn', 'ดูสินค้า')}</Link>
          </div>
        </div>
      </div>
    </section>
  );
}